import { DatePicker, Select, Table, TableColumnsType } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getTextList } from '../../../api/statistics.api';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import exportTable from '../../../lib/exportTable';
import { IGetTextList, ITextItem } from '../../../models/statistics.model';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';
import DownloadButton from '../../DownloadButton';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Pagination from '../../Pagination';
import Radio from '../../Radio';
import SelectCampus from '../../SelectCampus';
import _ from 'lodash';
import exportTitleTable from '../../../lib/exportTitleTable';
import TableEmpty from '../../common/TableEmpty';

const List = () => {
  const { t, i18n } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { data: res, isLoading, error, execute } = useAxios<IGetTextList>();
  // for excel data download
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetTextList>();

  const [campusCode, setCampusCode] = useState<string>("");
  const [smsType, setSmsType] = useState('SMS');
  const [date, setDate] = useState(moment().format('YYYYMM'));
  const [page, setPage] = useState(1);
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [resData, setResData] = useState<ITextItem[]>([]);
  const [excelCampusName, setExcelCampusName] = useState<string>();
  const [excelSmsType, setExcelSmsType] = useState<string>();

  useEffect(() => {
    if (isFirstRun) {
      return setIsFirstRun(false);
    }
    doGetTextList();
  }, [page]);

  useEffect(() => {
    if (res) {
      const _data: ITextItem[] = _.cloneDeep(res.data);
      let tempExcelCompanyName = "";
      let tempExcelSmsType = "";

      if (res?.data.length) {
        _data.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
          item.sendDate = (item.sendDate) ? item.sendDate : '-';
          item.status = (item.status === '06' || item.status === '1000') ? t('sms.list.column7') : item.status;

          if(!tempExcelCompanyName) {
            if(!campusCode) {
              tempExcelCompanyName = t('common.text.all');
            } else {
              tempExcelCompanyName = item.campusKorName;
            }
          }

          if(!tempExcelSmsType) {
            tempExcelSmsType = item.smsType;
          }
        });
      }

      setExcelCampusName(tempExcelCompanyName);
      setExcelSmsType(tempExcelSmsType);
      setResData(_data);
    }
  } ,[res]);

  useEffect(() => {
    if (res2 && isLoading2) {

      const _data: ITextItem[] = _.cloneDeep(res2.data);
      if (res2?.data.length) {
        _data.forEach((item: any) => {
          item.sendDate = (item.sendDate) ? item.sendDate : '-';
          item.status = (item.status === '06' || item.status === '1000') ? t('sms.list.column7') : item.status;
        });
      }

      const currentDate = moment(new Date());

      let excelTitle = t('statistics.text.1');
      let arrSubTitle = [];

      let today = '';
      if(currentDate.format('YYYYMM') === date) {
        today = currentDate.format('DD');
      } else {
        today = moment(date).add(1, 'month').subtract(1, 'day').format('DD');
      }

      let campusName = '';
      if(campusCode) {
        campusData?.map((item) => {
          if(item.campusCode === campusCode) {
            campusName = i18n.language === 'ko' ? item.campusKorName : item.campusEngName;
          }
        });
      } else {
        campusName = t('common.text.all');
      }

      arrSubTitle.push(t('common.excel.campus') + " : " + campusName);
      arrSubTitle.push(t('common.excel.period') + " : " + date.slice(0, 4) + date.slice(4, 6) + '01 ~ ' + date.slice(0, 4) + date.slice(4, 6) + today);
      arrSubTitle.push(t('statistics.text.column1') + " : " + excelSmsType);
      

      exportTitleTable(columns, _data, `${t('statistics.text.1')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.studentEnrolled.8'), [12, 10, 20, 20, 10, 10, 12, 50], excelTitle, arrSubTitle);
    }
  }, [res2, isLoading2]);

  const doGetTextList = (_page?: number, isForExcel = false) => {
    const param: any = {
      pageNo: _page || page,
      perPage: isForExcel ? 999999999 : config.pageSize,
      year: Number(date.slice(0, 4)),
      month: Number(date.slice(4, 6)),
    };

    if (auth.hqYn === 'Y' && campusCode) {
      param.campusCode = campusCode;
    } else if (auth.hqYn === 'N' && currentCampus) {
      param.campusCode = currentCampus;
    }
    if (smsType) {
      param.smsType = smsType;
    }

    isForExcel ? execute2(getTextList(param)) : execute(getTextList(param));
  };

  const onSearch = () => {
    doGetTextList(1);
  };

  const onExportTable = () => {
    doGetTextList(1, true);
  };

  const columns: TableColumnsType<ITextItem> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
      width: 174,
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
      width: 174,
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
      width: 248,
    },
    {
      title: t('statistics.studentRetire.column6'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
      width: 268,
    },
    {
      title: t('statistics.text.column1'),
      dataIndex: 'smsType',
      key: 'smsType',
      align: 'center',
      width: 140,
    },
    {
      title: t('student.student.column4'),
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 140,
    },
    {
      title: t('statistics.sms.column1'),
      dataIndex: 'sendDate',
      key: 'sendDate',
      align: 'center',
      width: 242,
    },
    {
      title: t('common.column.contents'),
      dataIndex: 'content',
      key: 'content',
      align: 'center',
      width: '*',
      render: value => {
        return (<div className='text-left ellipsis1'>{value}</div>);
      }
    },
  ];

  return (
    <>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
              {auth.hqYn === 'Y' ? (
                <SelectCampus
                  placeholder={t('statistics.regularTest.placeholder2')}
                  value={campusCode}
                  onChange={(value: string) => setCampusCode(value)}
                  hasAll={true}
                />
              ) : (
                <SelectCampus />
              )}
            </li>
            <li>
              <label>{t('sms.list.column1')}</label> {/* 기간 */}
              <div className="date-picker__area">
                <DatePicker
                  value={date ? moment(date) : undefined}
                  onChange={(e) => {
                    if (e === null) setDate('');
                    else setDate(moment(e).format('YYYYMM'));
                  }}
                  picker="month"
                />
              </div>
            </li>
            <li>
              <div>
                <Radio
                  checked={smsType === 'SMS'}
                  onChange={() => setSmsType('SMS')}
                  text="SMS"
                />
                <Radio
                  className="ml-3"
                  checked={smsType === 'LMS'}
                  onChange={() => setSmsType('LMS')}
                  text="LMS"
                />
              </div>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={onSearch}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>	

      {(isLoading || isLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      {resData?.length ? (
        <>
          <div className="comm-table__area">
            <Table
              columns={columns}
              dataSource={resData}
              pagination={{
                current: page,
                pageSize: config.pageSize,
              }}
              rowKey={'rowIdx'}
            />
          </div>
          <div className="comm-bx__between">
            <DownloadButton onClick={onExportTable} />
            <div className="common-paging center">
              <Pagination count={res?.total || 0} page={page} setPage={setPage} />
            </div>
          </div>
        </>
      ) : (
        <TableEmpty text={t('statistics.appday.text1')} />
      )}
    </>
  );
};

export default List;
